exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css);", ""]);

// module
exports.push([module.id, "body{background:#000}.App{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/App.sass
// module id = 110
// module chunks = 0